import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';

export interface ContactInfo {
  company: string;
  legalName: string;
  phone: string;
  phoneLink: string;
  email: string;
  address: string;
  hours: string;
  emails: { devices: string; invoicing: string; billing: string };
  contactFormUrl: string;
}

@Injectable({ providedIn: 'root' })
export class ContactInfoService {
  private cache$?: Observable<ContactInfo>;

  constructor(private http: HttpClient) {}

  get(): Observable<ContactInfo> {
    if (!this.cache$) {
      this.cache$ = this.http.get<ContactInfo>('assets/contact-info.json').pipe(shareReplay(1));
    }
    return this.cache$;
  }
}
